<template lang="pug">
  .download-wrapper(@click="onDownloadList")
    .download-icon(v-if="messagesData.status == 0", style="color: #9b9d9f")
      i
    .download-icon(v-else-if="messagesData.status == 1" ,style="color:#ffc723")
      i
    .download-icon(v-else, style="color:#9b9d9f")
      i
    p 下载中心
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '@/mixins/modules/Udesk'
import Api_ from '@/mixins/modules/basicInformation'
import { root } from '@/plugins/Fetch'
export default {
  /**
 * @author xiao_wei
 * @description 下载中心
 */
  name: 'download-center',
  mixins: [Api, Api_],
  data () {
    return {}
  },
  mounted () {
    if (this.currentUser.from !== 'BOSS') {
      this.initUdesk()
    }
  },
  computed: {
    // 判断如果下载正在进行中 则修改icon颜色
    ...mapGetters({
      messagesData: 'messagesData',
      currentUser: 'currentUser',
    }),
  },
  methods: {
    initUdesk () {
      // 获取store_id
      let storeInfo = this.currentUser.store
      // 请求签名参数拼接
      let info = {
        nonce: Math.random().toString(36).substr(2),
        timestamp: new Date().getTime(),
        web_token: `mgr_${storeInfo.store_id}_${this.currentUser.id}@vchangyi.com`,
        im_user_key: '59cb0cef3cac83b496e3bb1b44f2ba6f',
      }
      // 判断环境
      let env = 'prod'
      if (root.indexOf('dev') >= 0) {
        env = 'dev'
      } else if (root.indexOf('test') >= 0) {
        env = 'test'
      }
      // session_key 对于同一个门店的不同客户，开启不同的会话窗口
      let sessionKey = `${storeInfo.store_id}${this.currentUser.id}`
      // 请求签名
      this.getEncryptedSign({
        sign: `nonce=${info.nonce}&timestamp=${info.timestamp}&web_token=${info.web_token}&${info.im_user_key}`,
      }).then(res => {
        if (res.result.code === 0 && res.response.status === 200) {
          info.signature = res.result.data.sign
        }
        let scriptText = document.createElement('script')
        scriptText.type = 'text/javascript'
        let code = `(function (a, h, c, b, f, g) { a['UdeskApiObject'] = f; a[f] = a[f] || function () { (a[f].d = a[f].d || []).push(arguments) }; g = h.createElement(c); g.async = 1; g.charset = 'utf-8'; g.src = b; c = h.getElementsByTagName(c)[0]; c.parentNode.insertBefore(g, c) })(window, document, 'script', 'https://assets-cli.udesk.cn/im_client/js/udeskApi.js', 'ud')
        ud({
          'code': '4e8egi3f',
          'link': 'https://1864224.udesk.cn/im_client/?web_plugin_id=110531',
          'mode': 'inner',
          'session_key': '${sessionKey}',
          'customer': {
            'c_email':'${env}${storeInfo.store_id}@vchangyi.com',
            'c_name': '${storeInfo.store_name}',
            'c_phone': '${storeInfo.business_phone}_${storeInfo.store_id}',
            'c_cf_门店名称': '${storeInfo.store_name}', // 门店名称
            'c_cf_地址': '${storeInfo.province_name}省${storeInfo.city_name}市${storeInfo.district_name}${storeInfo.address}', // 地址
            'c_cn_title': '默认主题',
            'c_cn_门店名称': '${storeInfo.store_name}',
            'c_cn_门店客户': '${this.currentUser.name}',
            'c_cn_门店标签': '门店后台',
            'c_cn_门店地址': '${storeInfo.province_name}省${storeInfo.city_name}市${storeInfo.district_name}${storeInfo.address}',
            'nonce': '${info.nonce}',          
            'timestamp': '${info.timestamp}',
            'web_token': '${info.web_token}',
            'signature': '${info.signature}',
          }
        });`
        // 处理IE浏览器不能编辑script标签的问题
        try {
          scriptText.appendChild(document.createTextNode(code))
        } catch (er) {
          scriptText.text = code
        };
        document.body.appendChild(scriptText)
      }).catch(err => {
        console.log(err)
      })
    },
    onDownloadList () {
      this.$router.push({
        name: 'downloadList',
      })
    },
  },
}
</script>

<style scoped>
.download-wrapper {
  display: flex;
  align-items: center;
  margin-right: 50px;
  cursor: pointer;
}
.download-wrapper > .download-icon {
  position: relative;
  z-index: 1;
  width: 16px;
  height: 16px;
  margin-right: 5px;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.download-wrapper > .download-icon::after {
  content: "";
  position: absolute;
  width: 14px;
  height: 2px;
  border-radius: 5px;
  background-color: currentColor;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.download-wrapper > .download-icon > i {
  position: relative;
  display: flex;
  width: 15px;
  height: 12px;
}
.download-wrapper > .download-icon > i::before,
.download-wrapper > .download-icon > i::after {
  position: absolute;
  content: "";
}

.download-wrapper > .download-icon > i::before {
  width: 6px;
  height: 6px;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: currentColor;
}
.download-wrapper > .download-icon > i::after {
  width: 0;
  height: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  border-color: currentColor transparent transparent transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/generics/DownloadCenter.vue